import * as React from 'react'
import { CircularProgress, createStyles, Theme, WithStyles, withStyles, Typography, Icon, Table, TableBody, TableRow, TableCell, IconButton, TableHead, LinearProgress } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { fetchDocToSign, fetchOtherDoc } from 'src/core/redux/action/dashboardAction'
import { mapValuesContractual  } from 'src/shared/utils/helpers'
import { ISignature } from 'src/type/signature'
import PcDialog from 'src/shared/Dialog/PcDialog'
import BtnActions from 'src/shared/Btn/BtnActions'
import Btn from 'src/shared/Btn/Btn'
import Alert from 'src/shared/Alert/Alert'
import autobind from 'autobind-decorator'
import { getUrlSign, getDocumentUrl } from 'src/core/redux/action/signaturesAction'
import {submit, isInvalid} from 'redux-form'
import { fetchEnterprise, updateEnterprise } from 'src/core/redux/action/enterpriseInfosAction'
import { IModal } from 'src/type/modal'
import { ModalAction } from 'src/core/redux/action/modalActions'
import { Fender } from 'src/shared/Fender/Fender'
import InformationContractualForm from 'src/page/Consumer/Enterprise/forms/InformationContractualForm'
import DashboardPanel from 'src/page/Consumer/Dashboard/DashboardPanel'
import DashboardLoading from 'src/page/Consumer/Dashboard/DashboardLoading'

const styles = (t: Theme) => createStyles({
  tableSignatures: {
    tableLayout: "fixed",
    "& tr .signature-name": {
      overflow: "hidden",
      width: "calc(100% - 130px)",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& tr .signature-action": {
      width: "130px"
    }
  }
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>  {
}

interface IState {
  docToSign: ISignature[];
  docNotToSign: ISignature[];
  modal: boolean;
  modalType: string | undefined;
  documentIdSelected: string;
  isFetchingDocToSign: boolean;
  isFetchingDocNotToSign: boolean;
}

class DashboardSignatures extends React.Component<IProps, IState> {
  state = {
    docToSign: [] as ISignature[],
    docNotToSign: [] as ISignature[],
    modal: false,
    modalType: undefined,
    documentIdSelected: "",
    isFetchingDocToSign: false,
    isFetchingDocNotToSign: false
  }

  componentDidMount(){
    const {fdocToSign, fdocNotToSign, promisesWithProgress, toastError} = this.props
    this.setState({isFetchingDocToSign: true, isFetchingDocNotToSign: true})
    promisesWithProgress(
      fdocToSign().then(res => this.setState({docToSign: res.data})).catch(err => toastError(err.msg)).finally(() => this.setState({isFetchingDocToSign: false})),
      fdocNotToSign().then(res => this.setState({docNotToSign: res.data})).catch(err => toastError(err.msg)).finally(() => this.setState({isFetchingDocNotToSign: false})),
    )
  }

  render() {
    const {t, classes, enterprise, user} = this.props
    const { docToSign, docNotToSign, modalType, isFetchingDocToSign, isFetchingDocNotToSign} = this.state
    return (
      <div>
        <DashboardPanel
          label={t.last_documents}
          icon="gesture"
          redirect="signature"
          headerClickableRedirectOnly
        >
          {(isFetchingDocToSign && isFetchingDocNotToSign) && <DashboardLoading />}
          {(!isFetchingDocToSign && !isFetchingDocNotToSign) && 
            <>
            {(docToSign.length > 0 || docNotToSign.length > 0) &&
              <Table className={classes.tableSignatures}>
                <TableHead>
                  <TableRow>
                    <TableCell className="signature-name">{t.signature_name}</TableCell>
                    <TableCell className="signature-action">{t.actions}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* --- Doc to sign --- */}
                  {(docToSign.length > 0 && !isFetchingDocToSign) && docToSign.map(dts => (
                      <TableRow key={dts.id}>
                          <TableCell className="signature-name">{dts.name}</TableCell>
                          <TableCell className="signature-action">
                            <Btn color='primary' onClick={this.verificationSign(dts)} icon='edit' variant='contained' disabled={!(user && !!user.phone)}>
                              {t.sign}
                            </Btn>
                        </TableCell>
                      </TableRow>
                    ))
                  }

                  {/* --- Doc not to sign --- */}
                  {(docNotToSign.length > 0 && !isFetchingDocNotToSign) && docNotToSign.map(dnts => (
                      <TableRow key={dnts.id}>
                        <TableCell className="signature-name">{dnts.name}</TableCell>
                        <TableCell className="signature-action">
                            <IconButton aria-label={t.downloading} style={{cursor: 'pointer'}} onClick={this.handleDownload(dnts.document_id)}>
                              <Icon>get_app</Icon>
                            </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            }
            </>
          }
          {(!isFetchingDocToSign && !isFetchingDocNotToSign && docToSign.length === 0 && docNotToSign.length === 0) &&
            <Fender text={t.Dashboard_no_signatures} />
          }
        </DashboardPanel>

        <PcDialog
            open={this.state.modal}
            {...modalType === "EDIT_CONTRACTUAL" && {title: t.EnterpriseDetail_info_contractual_title_edit}}
            maxWidth="md"
            fullWidth={true}
            {...modalType === "EDIT_CONTRACTUAL" && {actions: (
                <BtnActions
                    cancelHandler={() => this.toggleModal(false)}
                    confirmHandler={this.submitFormRemotely}
                    disableNext={this.props.isInfoContractualFormValid}
                    confirmLabel={t.save}
                />)
            }}
        >
            {modalType === "EDIT_CONTRACTUAL" &&
                <>
                    <Alert type="warning">{t.EnterpriseDetail_info_contractual_modal_confirm}</Alert>
                    {enterprise.person_to_notify_email &&
                        <InformationContractualForm
                            onSubmit={this.handleSubmitForm} 
                            initialValues={{
                            person_to_notify_first_name: enterprise.person_to_notify_first_name,
                            person_to_notify_last_name: enterprise.person_to_notify_last_name,
                            person_to_notify_email: enterprise.person_to_notify_email,
                            person_to_notify_address: enterprise.person_to_notify_address,
                            emir_status: enterprise.emir_status,
                            lei: enterprise.lei,
                            rcs_city_legal_representative: enterprise.rcs_city_legal_representative,
                            siren_legal_representative: enterprise.siren_legal_representative,
                            }}
                        />
                    }
                    {!enterprise.person_to_notify_email &&
                        <InformationContractualForm onSubmit={this.handleSubmitForm} />
                    }
                </>
            }
            {modalType === "PREPARE_TUNNEL" && 
                <>
                    <Typography variant="title" align="center">{t.signature_tunnel_prepare_waiting}</Typography><br/>
                    <LinearProgress />
                </>
            }
            {!modalType && <CircularProgress size={32}/>}
        </PcDialog>
      </div>
    )
  }

  @autobind
  private submitFormRemotely() {
      this.props.submitForm(submit("informationContractualForm"));
  };

  @autobind
  private handleSubmitForm(values){
    const {updateEnterpriseInfo, promisesWithProgress, toastError, enterprise, toastSuccess, t} = this.props
    promisesWithProgress(
      updateEnterpriseInfo(enterprise.id, mapValuesContractual(values)).then(res => {
        toastSuccess(t.EnterpriseDetail_info_contractual_edit_sucess)
        this.setState({modalType: "PREPARE_TUNNEL"}, () => {
          setTimeout(() => {
            this.handleSign(this.state.documentIdSelected)
          }, 300)
        })
      }).catch(err => {
          toastError(err.msg)
      })
    )
  }

  @autobind
  private toggleModal(action){
      this.setState({modal: action})
  }

  @autobind
  private toggleModalType(type, callback?){
    if(callback){
      this.setState({modalType: type}, () => callback)
    } else {
      this.setState({modalType: type})
    }
  }

  verificationSign = document => e => {
    const {enterprise, fetchEnterprise} = this.props
    fetchEnterprise(enterprise.id).then(res => {
      if(res.can_edit_contractual_data === true && 
          (document.category_document && document.category_document.indexOf("document-cadre") > -1 && document.must_be_signed === true)){
          this.setState({documentIdSelected: document.document_id})
          this.toggleModalType("EDIT_CONTRACTUAL", this.toggleModal(true))
      } else {
          this.toggleModalType("PREPARE_TUNNEL", this.toggleModal(true))
          this.handleSign(document.document_id)
      }
    })
  }

  @autobind
  private handleSign(id: string){
    const {getLinkToSign, enterprise, promisesWithProgress, toastError} = this.props
    promisesWithProgress(
        getLinkToSign(enterprise.id, id).then(res => {
            window.location.href = res
        }).catch(err => {
            toastError(err.msg)
        }).finally(() => this.toggleModal(false))
    )
  }

  handleDownload = id => e => {
    const {promisesWithProgress, toastError, t} = this.props
    promisesWithProgress(
        this.props.getDocumentUrl(id).then(res => {
          if(res) {
            window.open(res, "_blank")
          } else {
            toastError(t.random_error)
          }
        }).catch(err => {
          toastError(err.msg)
        })
      )
  }
}

const state2props = (state: RootState) => ({
  mapName: state.utils.mapCategories,
  mapProductType: state.utils.mapProductType,
  user: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected,
  isInfoContractualFormValid: isInvalid("informationContractualForm")(state),
});

const dispatch2props = (dispatch: any) => ({
  fetchEnterprise: (id: string) => dispatch(fetchEnterprise(id)),
  fdocToSign: () => dispatch(fetchDocToSign()),
  fdocNotToSign: () => dispatch(fetchOtherDoc()),
  submitForm: (handerSubmit) => dispatch(handerSubmit),
  updateEnterpriseInfo: (id: string, data: any) => dispatch(updateEnterprise(id, data)),
  getLinkToSign:(enterpriseId: string, docId: string) => dispatch(getUrlSign(enterpriseId, docId)),
  getDocumentUrl: (docId: string) => dispatch(getDocumentUrl(docId)),
  openModal: (modal?: IModal) => dispatch(ModalAction.openModal(modal)),
  closeModal: () => dispatch(ModalAction.closeModal()),
  resetModal: () => dispatch(ModalAction.resetModal()),
});

export default compose(
  withI18n,
  withRouter,
  withGlobalProgress,
  withToast,
  withStyles(styles),
  connect(state2props, dispatch2props),
)(DashboardSignatures)



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/tabs/DashboardSignatures.tsx